import script from "./MobileFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileFooter.vue?vue&type=script&setup=true&lang=js"

import "./MobileFooter.vue?vue&type=style&index=0&id=af6a1c36&scoped=true&lang=less"

import exportComponent from "/var/www/tz-official-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af6a1c36"]])

export default __exports__